export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-contrast-64075e0076579256d7a0908f18e195f7.svg";